import jmespath from 'jmespath';

let stateRegs = [];

 let productCode = document.getElementById('product-code').innerHTML;
 
 // if feed data is not in session storge, get it
 if (!sessionStorage.feed) {
  const feed = axios.get('https://pndata.andersonsinc.com/misc/StateRegistrations');
  sessionStorage.feed = JSON.stringify(feed.data.StateRegistrations);
  stateRegs = feed.data.StateRegistrations;
} else {
  stateRegs = JSON.parse(sessionStorage.feed);
}

let registrationsString = '';
let states = jmespath.search(stateRegs, "[?\"Part Code\" == '0000000000"+productCode+"'].State");
// make unique and sort
states = [...new Set(states)]; 
states.sort();
// make a comma separated string
registrationsString = states.join(', ');

let registrationNumber = jmespath.search(stateRegs, "[?\"Part Code\" == '0000000000"+productCode+"'][\"Basic Reg No\"] | [0][0]");

// update the DOM
document.getElementById('states-registered').innerHTML = registrationsString;
document.getElementById('basic-reg-no').innerHTML = registrationNumber;